import store from "../store"; // Ensure the path is correct
import { refreshAccessToken } from "../store/user";
import { toast } from "react-toastify";
import api from "./api";
import shopApi from "./shop";

export const configureAxios = () => {
    // Request interceptor: Add Authorization header
    api.interceptors.request.use(
        (config) => {
            const state = store.getState();
            const token = state?.user?.userConnected?.accessToken;
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response interceptor: Handle 401 errors (token expiration)
    api.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response?.status === 401) {
                const state = store.getState();
                const refreshToken = state?.user?.userConnected?.refreshToken;
                if (refreshToken) {
                    try {
                        // Dispatch action to refresh the access token
                        const newAccessToken = await store.dispatch(refreshAccessToken(refreshToken));
                        // Retry the failed request with the new token
                        error.config.headers.Authorization = `Bearer ${newAccessToken}`;
                        return api.request(error.config);
                    } catch (err) {
                        console.error("Error refreshing access token:", err);
                        // Déconnecter l'utilisateur et rediriger vers la page de connexion
                        shopApi.logout(refreshToken).then(() => {
                            toast.error("Votre session a expiré. Veuillez vous reconnecter.", {
                                theme: "colored",
                                autoClose: 20000,
                            });
                        });
                        return Promise.reject(err);
                    }
                }
            }

            return Promise.reject(error); // Reject the error to handle it further down
        }
    );
};

export default api;
